module.exports = __webpack_public_path__ + "static/machine-learning-specialty-a645284826fdd3103577d6932c3047a5.png";